<div class="tableContainer" [ngClass]="{ loading: loading }">
  @if (search && searchTerm) {
    <div>
      <mat-form-field appearance="outline">
        <mat-label>{{ "TABLES.GENERAL.FILTER" | translate }}</mat-label>
        <input [formControl]="searchTerm" matInput placeholder="{{ 'TABLES.GENERAL.FILTER' | translate }}..." />
      </mat-form-field>
    </div>
  }

  @if (loading) {
    <mat-spinner></mat-spinner>
  } @else {
    <div style="overflow-x: auto">
      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortChange($event)">
        <!-- mobile table -->
        @if (mobileTable) {
          <ng-container [matColumnDef]="headers[0].visualName">
            <td mat-cell *matCellDef="let element">
              <div class="row w-100 py-3">
                @for (header of headers; track header) {
                  <div class="col-3" [ngClass]="header.columnStyles?.class">
                    @if (!header.buttons) {
                      <p>
                        <span style="font-size: 10px; display: block">{{ "TABLES." + id + "." + header.visualName | translate }}</span>
                        <span>
                          <!-- SWITCHING CONTENT STYLES -->
                          @if (header.currency && header.mappedTo) {
                            {{ element[header.mappedTo] | currency: "EUR" : "symbol" : ".2-2" : "nl" }}
                          }
                          @if (header.resolver) {
                            {{ header.resolver(element) }}
                          }
                          @if (header.mappedTo && header.mappedTo && !header.currency) {
                            {{ element[header.mappedTo!] }}
                          }
                          @if (header.link) {
                            <a [routerLink]="makeFullLink(header.link, element)">{{ header.visualName | titlecase }}</a>
                          }
                          @if (header.click) {
                            <button mat-icon-button [color]="header.click.color" (click)="header.click.clickHandler(element)">
                              <mat-icon [matTooltip]="header.tooltip ?? ''">{{ header.click.icon }}</mat-icon>
                            </button>
                          }
                        </span>
                      </p>
                    }
                  </div>
                }
              </div>
            </td>
          </ng-container>
        }
        <!-- desktop table -->
        @if (!mobileTable) {
          @for (header of headers; track header) {
            <ng-container [matColumnDef]="header.visualName">
              @if (header.sorting?.sort) {
                <th
                  [style]="
                    header.columnStyles?.width
                      ? 'width: ' + header.columnStyles?.width + ';'
                      : '' + header.columnStyles?.align
                        ? 'text-align: ' + header.columnStyles?.align + ';'
                        : ''
                  "
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  <span>{{ "TABLES." + id + "." + header.visualName | translate }}</span>
                </th>
              }
              @if (!header.sorting?.sort) {
                <th
                  [style]="
                    header.columnStyles?.width
                      ? 'width: ' + header.columnStyles?.width + ';'
                      : '' + header.columnStyles?.align
                        ? 'text-align: ' + header.columnStyles?.align + ';'
                        : ''
                  "
                  mat-header-cell
                  *matHeaderCellDef
                >
                  <span>{{ "TABLES." + id + "." + header.visualName | translate }}</span>
                </th>
              }
              <td
                class="templates"
                style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap"
                [style]="'text-align:' + header.columnStyles?.align"
                class="pe-4"
                mat-cell
                *matCellDef="let element"
              >
                @if (header.currency && header.mappedTo) {
                  {{ element[header.mappedTo] | currency: "EUR" : "symbol" : ".2-2" : "nl" }}
                } @else {
                  @if (header.visualName === "PUBLISHED_TOGGLE" && header.click) {
                    <button
                      mat-icon-button
                      [color]="element['active'] ? 'primary' : 'warn'"
                      (click)="header.click.clickHandler(element)"
                      [matTooltip]="'COMPONENTS.ALL_QUESTIONNAIRES.' + (element.active ? 'DEACTIVATE' : 'PUBLISH') + '_QUESTIONNAIRE.TOOLTIP' | translate"
                      [attr.aria-label]="'COMPONENTS.ALL_QUESTIONNAIRES.' + (element.active ? 'DEACTIVATE' : 'PUBLISH') + '_QUESTIONNAIRE.TOOLTIP' | translate"
                    >
                      <mat-icon>{{ element["active"] ? "check_circle" : "cancel" }}</mat-icon>
                    </button>
                  } @else {
                    @if (header.mappedTo) {
                      {{ element[header.mappedTo] }}
                    } @else {
                      @if (header.resolver) {
                        {{ header.resolver(element) }}
                      } @else {
                        @if (header.link) {
                          <a [routerLink]="makeFullLink(header.link, element)">{{ header.visualName | titlecase }}</a>
                        } @else {
                          @if (header.click) {
                            <button
                              mat-icon-button
                              [color]="header.click.color"
                              (click)="header.click.clickHandler(element)"
                              [attr.aria-label]="header.visualName"
                              [matTooltip]="header.tooltip ?? ''"
                            >
                              <mat-icon>{{ header.click.icon }}</mat-icon>
                            </button>
                          } @else {
                            @if (header.regularButton) {
                              <button mat-stroked-button [color]="header.regularButton.color" (click)="header.regularButton.clickHandler(element)">
                                <mat-icon [matTooltip]="header.tooltip ?? ''">{{ header.regularButton.icon }}</mat-icon>
                              </button>
                            } @else {
                              <ng-container [ngTemplateOutlet]="header.customTemplate ?? null" [ngTemplateOutletContext]="{ data: element }"> </ng-container>
                            }
                          }
                        }
                      }
                    }
                  }
                }
              </td>
            </ng-container>
          }
          <tr mat-header-row *matHeaderRowDef="visibleHeaders" class="visible"></tr>
        }
        <tr mat-row *matRowDef="let row; columns: visibleHeaders"></tr>
        <tr *matNoDataRow>
          <td colspan="100%">{{ "TABLES.GENERAL.NO_DATA" | translate }}</td>
        </tr>
      </table>
    </div>
  }
  @if (pageSizes) {
    <mat-paginator [pageSizeOptions]="pageSizes" (page)="onPageSizeChange($event)" [ngClass]="{ hidden: dataSource.data.length < pageSizes[0] }"></mat-paginator>
  }
</div>
